import { FunctionComponent } from 'react';
import FursysTopWrapper from './fursysTop.style';
import { getStaticImageUrl } from '@utils/createImageUrl';
import CloseIcon from '../../public/icon/CloseMedium';

const FursysTop: FunctionComponent = () => {
  return (
    <FursysTopWrapper>
      <div className="fursysTop">
        <div className="fursysTop--logoWrapper desktop">
          <img className="fursys-logo" src={getStaticImageUrl({ fileName: 'fursys-logo.png' })} />
          <CloseIcon />
          <img src={'/lawtalkLogo-orange.png'} className="lawtalk-logo" />
        </div>
        <div className="fursysTop--logoWrapper mobile">
          <img className="fursys-logo" src={getStaticImageUrl({ fileName: 'fursys-logo.png' })} />
          <CloseIcon width="14px" height="14px" />
          <img src={'/lawtalkLogo-orange.png'} className="lawtalk-logo" />
        </div>
        <p className="fursysTop--title">
          변호사님의
          <br />
          사무실도
          <br />
          <span className="fursysTop--title_bold">로톡이 고민합니다.</span>
        </p>
        <p className="fursysTop--sub_title">
          변호사 사무실, 의뢰인에게는&nbsp;
          <br className="mobile" />
          변호사님의 첫인상입니다.
        </p>

        <div className="fursys-content">
          <img className="quotation-right" src={getStaticImageUrl({ fileName: 'quotation-right.png' })} />
          <br />
          <img className="contentImg" src={getStaticImageUrl({ fileName: 'desktop-content.png' })} />
          <br />
          <img className="quotation-left" src={getStaticImageUrl({ fileName: 'quotation-left.png' })} />
          <p className="fursys-content--main">
            변호사님의 고민을 해결해드리기 위해
            <br />
            로톡이 최고의 사무가구 브랜드&nbsp;
            <br className="mobile" />
            퍼시스 그룹과 제휴를 맺었습니다.
            <br />
            아울러, 무료 인테리어 컨설팅으로 개업의&nbsp;
            <br className="mobile" />첫 시작 순간부터 함께 도움을 드리겠습니다.
            <br />
            <span className="fursys-content--main-bold">
              변호사님을 위해 준비한&nbsp;
              <br className="mobile" />두 가지 혜택을 확인해보세요.
            </span>
          </p>
        </div>
      </div>
    </FursysTopWrapper>
  );
};

export default FursysTop;
